var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTomato({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269 24.54c-3.1.11-5.7 0-7.6.21-2.8.25-4.7.45-7.2 2.23l-1 69.32c3 1.18 6.4 2.3 9.7 2.51 4.1.3 6.8-.21 9.2-2.41zm-103.4 37.9c.1 5.95.3 11.01 1.5 14.14 2.3 5.22 7 9.88 26 13.92l22.5 4.78-19.5 11.82c-16.5 10.1-35.2 19.4-51.5 26.5 6.2.7 12.3 1.4 18.2 1.4 17.8-.1 34.6-3.9 55.3-18.1L234 106l.4-24.35c-25.5-5.62-46.5-11.68-68.8-19.21zm181.2 6.49c-19.5 6.69-34.4 10.97-56.4 14.16l.9 18.81-1.7 2.5c-6.8 10-18.4 13.3-27.9 12.7-9.5-.6-17.6-3.9-23.4-7.6l-3.2-2.1-2.2 18c-1.9 17.1-2.1 28.3-5.2 42.4 14.6-10.4 24.4-18.9 36.5-37.3l7.2-10.7 8.1 10c10.9 13 28.8 22.9 48.5 29-5.7-6.5-10.9-14.5-12-25l-1.4-14.1 13.9 4.6c20.6 6.6 26.9 6.1 33.9 3.7 2.9-.9 6.7-2.6 10.6-4.5l-80.7-27.61 27.3-8.15c14.2-4.24 20.9-9.1 24.6-13.94 1-1.5 1.9-3.14 2.6-4.87zM405.5 132l-1.8.4c-17.4 4.2-24.3 9.5-35 13.1-7.4 2.3-15.6 2.8-26.7.9.4.6 1 1.2 1.5 1.8 5 5.5 12.2 11.6 18.8 20.2l13.2 17.2-21.9-2.6c-29.1-3.5-59.4-13.9-80.3-32.9-16.3 21.4-31.5 30.4-57.2 48.6l-25.8 18.4 11.3-29.1c8.4-21.1 9.3-31.3 10.7-46.3-17.3 8.4-33.7 11.5-49.5 11.6-18.7 0-36.5-3.7-55.2-6.4-.4 0-.8.1-1.2.2-59.84 46.2-68.94 115.5-68.87 150.3.17 94.2 26.73 186.7 222.47 190C408.9 490 475.4 388 474.5 293.2c-.8-60.6-12.3-124.4-69-161.2zm-258.4 34.3c13.2-.2 26.4 4.4 28.3 12.4-92.08 41.9-91.59 97.8-105.21 156.8-11.1-56.8-7.31-122.5 55.21-163.6 5.6-3.8 13.8-5.5 21.7-5.6z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomato);
export default __webpack_public_path__ + "static/media/tomato.3bc12b92fa86206da40812cd69926aac.svg";
export { ForwardRef as ReactComponent };